export function internalTool(args) {
  const {
    deleteConfirmText,
    usersUploaded,
    emailList,
    showCsvModal,
    internalToolName,
    internalToolPrompt,
    showDeleteModal,
    targetAudience,
    configuredValue,
    targetRole,
    placeholder,
    selectedOption,
    excludeNaResponders,
    takenNames,
    platformXProjectId,
    // Multilingual support
    langCodes = [],
    multilingualEnabled = false,
    translations = {},
    ratingOptionsByLang = {},
    defaultLanguage = "en",
    surveyPrompts = {},
  } = args;

  return {
    csv: null,
    deleteConfirmText,
    usersUploaded,
    emailList,
    showCsvModal,
    internalToolName,
    internalToolPrompt,
    showDeleteModal,
    targetAudience,
    targetRole,
    placeholder,
    selectedOption,
    excludeNaResponders,
    platformXProjectId,
    // Multilingual support
    activeLanguage: defaultLanguage,
    defaultLanguage,
    langCodes,
    multilingualEnabled,
    translations,
    ratingOptionsByLang,
    surveyPrompts,
    surveyPrompt(key) {
      return (
        this.surveyPrompts[this.activeLanguage]?.[key] ||
        this.surveyPrompts[this.defaultLanguage]?.[key] ||
        ""
      );
    },
    get currentRatingOptions() {
      if (
        !this.ratingOptionsByLang ||
        Object.keys(this.ratingOptionsByLang).length === 0
      ) {
        return [];
      }
      return (
        this.ratingOptionsByLang[this.activeLanguage] ||
        this.ratingOptionsByLang[this.defaultLanguage] ||
        []
      );
    },
    hasTranslation(lang) {
      return this.translations[lang] && this.translations[lang].prompt;
    },
    get allTranslated() {
      if (!this.multilingualEnabled || this.langCodes.length === 0) return true;
      return this.langCodes.every((lang) => this.hasTranslation(lang));
    },
    setRadioButtons() {
      if (this.targetAudience != configuredValue) {
        this.targetAudience = configuredValue;
      }
    },
    isSelected(option) {
      return option == this.targetAudience;
    },
    isDuplicateName() {
      return (
        !!this.internalToolName &&
        takenNames.find((n) => n.trim() === this.internalToolName.trim())
      );
    },
    formValid() {
      if (
        this.internalToolName &&
        !!this.internalToolName.trim().length &&
        !this.isDuplicateName() &&
        this.internalToolPrompt
      ) {
        if (this.targetAudience === "platformx") {
          return (
            this.platformXProjectId !== "0" && this.platformXProjectId !== null
          );
        } else if (this.targetAudience === "custom") {
          return this.usersUploaded;
        }
        return true;
      } else {
        return false;
      }
    },
  };
}
